import React, { useState, useEffect } from 'react';
import { TouchableOpacity } from 'react-native';
import { Bell, BellOff } from 'lucide-react-native';
import { Text, useThemeName } from '@tamagui/core';
import { XStack } from '@tamagui/stacks';
import AsyncStorage from '@react-native-async-storage/async-storage';

const PUSH_NOTIFICATIONS_KEY = '@push_notifications_enabled';

interface PushNotificationToggleProps {
  onToggle?: (enabled: boolean) => void;
}

const PushNotificationToggle: React.FC<PushNotificationToggleProps> = ({ onToggle }) => {
  const themeName = useThemeName();
  const [isEnabled, setIsEnabled] = useState(true);

  useEffect(() => {
    loadPushNotificationSetting();
  }, []);

  const loadPushNotificationSetting = async () => {
    try {
      const saved = await AsyncStorage.getItem(PUSH_NOTIFICATIONS_KEY);
      if (saved !== null) {
        setIsEnabled(saved === 'true');
      }
    } catch (error) {
      console.warn('Błąd ładowania ustawień powiadomień:', error);
    }
  };

  const togglePushNotifications = async () => {
    const newValue = !isEnabled;
    setIsEnabled(newValue);

    try {
      await AsyncStorage.setItem(PUSH_NOTIFICATIONS_KEY, newValue.toString());
      onToggle?.(newValue);
    } catch (error) {
      console.warn('Błąd zapisywania ustawień powiadomień:', error);
    }
  };

  const backgroundColor = themeName === 'dark' ? '#374151' : '#f3f4f6';
  const borderColor = themeName === 'dark' ? '#4b5563' : '#d1d5db';
  const textColor = themeName === 'dark' ? '#ffffff' : '#374151';
  const iconColor = isEnabled 
    ? (themeName === 'dark' ? '#10b981' : '#059669')
    : (themeName === 'dark' ? '#6b7280' : '#9ca3af');

  return (
    <TouchableOpacity onPress={togglePushNotifications}>
      <XStack
        alignItems="center"
        paddingHorizontal="$3"
        paddingVertical="$2"
        borderRadius="$4"
        backgroundColor={backgroundColor}
        borderWidth={1}
        borderColor={borderColor}
        space="$2"
      >
        {isEnabled ? (
          <Bell size={16} color={iconColor} />
        ) : (
          <BellOff size={16} color={iconColor} />
        )}
        <Text 
          fontSize="$3" 
          color={textColor} 
          fontWeight="600"
        >
          {isEnabled ? 'ON' : 'OFF'}
        </Text>
      </XStack>
    </TouchableOpacity>
  );
};

export default PushNotificationToggle;
